import { useState, useEffect, useCallback } from 'react';
import firebase from '../config/firebase.config';

/**
 * Fetches all Jira tasks for a company from the jiraTasks subcollection.
 * Uses a one-time get() — tasks only change on manual imports, so a persistent
 * listener would incur unnecessary reads.
 */
const useJiraTasks = (companyId, connected) => {
  const [tasks, setTasks] = useState([]);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);

  const fetchTasks = useCallback(async () => {
    if (!companyId || !connected) {
      setTasks([]);
      setLoading(false);
      return;
    }

    setLoading(true);
    setError(null);

    try {
      const snapshot = await firebase
        .firestore()
        .collection('companyDatabase')
        .doc(companyId)
        .collection('jiraTasks')
        .orderBy('jiraUpdatedAt', 'desc')
        .get();

      setTasks(snapshot.docs.map((doc) => ({ _docId: doc.id, ...doc.data() })));
    } catch (err) {
      console.error('[useJiraTasks] fetch error:', err);
      setError(err);
    } finally {
      setLoading(false);
    }
  }, [companyId, connected]);

  useEffect(() => {
    fetchTasks();
  }, [fetchTasks]);

  return { tasks, loading, error, refetch: fetchTasks };
};

export default useJiraTasks;
